import { createSlice } from "@reduxjs/toolkit";

export interface FilterState {
  eventsType: any;
  location: any;
  currentPage: any;
  school: any;
  age: any;
  category: any;
  eventsMode: any;
  gender: any;
  zoneSearchBox: any;
  eventSearchBox: any;
  title: any;
  registrationsOpen: boolean;
  privateEvents: boolean;
  grade?: any;
  school_id: any;
  venue_address: any;
}

const initialState: FilterState = {
  eventsType: [],
  location: "",
  currentPage: 1,
  school: "",
  age: null,
  eventsMode: [],
  category: "",
  gender: "",
  zoneSearchBox: "",
  eventSearchBox: "",
  title: "",
  registrationsOpen: false,
  privateEvents: false,
  grade: null,
  school_id: [],
  venue_address: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    addFilter: (state, action) => {
      return (state = action.payload);
    },
    clearFilter: (state) => {
      return (state = initialState);
    },
  },
});

export const { addFilter, clearFilter } = filterSlice.actions;

export const filterItems = (state: { filter: FilterState }) => state.filter;

export default filterSlice.reducer;
